import "../styleSheets/dashboardDeliveredMessages.css";
import "../styleSheets/buttons.css";
import "../styleSheets/commonElements.css";
import { useMemo } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useUser } from "../contexts/UserContext";
import { useDeliveredMessagesBySender } from "../graphql/hooks";
import WidgetState from "./WidgetState";

function DashboardDeliveredMessages() {
  const navigate = useNavigate();
  const { t } = useTranslation("common");
  const { user, isAuthenticated } = useUser();
  const userId = user?.userId ?? "";

  const {
    data: deliveredMessages = [],
    isLoading,
    isError,
    error,
  } = useDeliveredMessagesBySender(userId, isAuthenticated && !!userId);

  const { successfulCount, unsuccessfulCount, readCount } = useMemo(() => {
    const successful = deliveredMessages.filter(
      (message) => message.status === "DELIVERED",
    ).length;
    const unsuccessful = deliveredMessages.filter(
      (message) => message.status === "FAILED",
    ).length;
    const read = deliveredMessages.filter(
      (message) =>
        message.status === "DELIVERED" && message.messageRead === true,
    ).length;

    return {
      successfulCount: successful,
      unsuccessfulCount: unsuccessful,
      readCount: read,
    };
  }, [deliveredMessages]);

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/"
        replace
        state={{ toast: { type: "info", message: t("common.signIn") } }}
      />
    );
  }

  function seeAllDeliveredMessages() {
    navigate("/Panel?selectedTab=deliveredMessages");
  }

  return (
    <section className="section-delivered-messages" aria-labelledby="delivered-messages-heading">
      <section className="delivered-header">
        <div className="delivered-header-left">
          <div className="icon-container delivered-messages-icon"></div>
          <h2 id="delivered-messages-heading" className="delivered-title">
            {t("deliveredMessage.deliveredMessages")}
          </h2>
        </div>

        <div className="delivered-count">
          {isLoading
            ? t("common.loading")
            : isError
              ? "—"
              : `${deliveredMessages.length} ${
                  deliveredMessages.length === 1
                    ? t("message.message")
                    : t("message.messages")
                }`}
        </div>
      </section>

      <section className="delivered-center">
        <WidgetState
          isLoading={isLoading}
          isError={isError}
          error={error}
          isEmpty={!isLoading && deliveredMessages.length === 0}
          emptyText={t("deliveredMessage.onScreenMessage.noDeliveredYet")}
          className="delivered-empty"
        >
          <>
            <div className="delivered-count-container">
              <div className="delivered-count-in-container">
                {successfulCount}
              </div>
              <div className="delivered-text-in-container">
                {t("deliveredMessage.successfulDelivered")}
              </div>
            </div>
            <div className="delivered-count-container">
              <div className="delivered-count-in-container">
                {unsuccessfulCount}
              </div>
              <div className="delivered-text-in-container">
                {t("deliveredMessage.unsuccessfulAttempts")}
              </div>
            </div>
            <div className="delivered-count-container">
              <div className="delivered-count-in-container">{readCount}</div>
              <div className="delivered-text-in-container">
                {t("deliveredMessage.readDelivered")}
              </div>
            </div>
          </>
        </WidgetState>
      </section>

      <section className="delivered-bottom">
        {deliveredMessages.length > 0 && (
          <button
            className="btn btn--white btn--size-md"
            onClick={seeAllDeliveredMessages}
          >
            {t("common.seeAll")}
          </button>
        )}
      </section>
    </section>
  );
}

export default DashboardDeliveredMessages;
